(() => {
  const BUTTON_SELECTOR = [
    '.button',
    '.shopify-challenge__button',
    '.customer button',
    'button.shopify-payment-button__button--unbranded',
  ].join(', ');

  function setPointerPosition(button, event) {
    const rect = button.getBoundingClientRect();
    button.style.setProperty('--button-pointer-x', `${event.clientX - rect.left}px`);
    button.style.setProperty('--button-pointer-y', `${event.clientY - rect.top}px`);
  }

  function clearPressedState(button) {
    button.classList.remove('is-pressed');
  }

  function enhanceButton(button) {
    if (!(button instanceof HTMLElement) || button.dataset.modernButtonReady === 'true') return;

    button.dataset.modernButtonReady = 'true';

    button.addEventListener(
      'pointermove',
      (event) => {
        if (event.pointerType && event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
        setPointerPosition(button, event);
      },
      { passive: true }
    );

    button.addEventListener('pointerleave', () => {
      clearPressedState(button);
      button.style.removeProperty('--button-pointer-x');
      button.style.removeProperty('--button-pointer-y');
    });
    button.addEventListener('pointerdown', () => button.classList.add('is-pressed'));
    button.addEventListener('pointerup', () => clearPressedState(button));
    button.addEventListener('pointercancel', () => clearPressedState(button));
    button.addEventListener('blur', () => clearPressedState(button));
  }

  function initContactForm(form) {
    if (!(form instanceof HTMLFormElement) || form.dataset.modernSubmitReady === 'true') return;

    const submitButton = form.querySelector('button[type="submit"]');
    if (!submitButton) return;

    form.dataset.modernSubmitReady = 'true';
    form.addEventListener('submit', (event) => {
      if (event.defaultPrevented) return;
      if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;
      if (submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') return;

      submitButton.setAttribute('data-button-state', 'pending');
      submitButton.setAttribute('aria-busy', 'true');
    });
  }

  function init(root = document) {
    if (root instanceof HTMLElement && root.matches(BUTTON_SELECTOR)) {
      enhanceButton(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(BUTTON_SELECTOR).forEach(enhanceButton);
    }

    if (root instanceof HTMLFormElement && root.id === 'ContactForm') {
      initContactForm(root);
    } else if (root.querySelectorAll) {
      root.querySelectorAll('form#ContactForm').forEach(initContactForm);
    }
  }

  init();

  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-button-state="pending"]:not(.loading)').forEach((button) => {
      button.removeAttribute('data-button-state');
      button.removeAttribute('aria-busy');
    });
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        init(node);
      });
    });
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
